import { useMemo } from 'react';

import { supportedTimezones } from '../timezones.js';

interface TimezoneSelectProps {
	defaultValue?: string;
	disabled?: boolean;
	name?: string;
	onChange?: (timezone: string) => void;
	required?: boolean;
	value?: string;
}

export function TimezoneSelect({
	defaultValue,
	disabled = false,
	name,
	onChange,
	required = true,
	value,
}: TimezoneSelectProps) {
	const currentTimezone = value ?? defaultValue;
	const timezones = useMemo(() => supportedTimezones(currentTimezone), [currentTimezone]);

	return (
		<select
			defaultValue={value === undefined ? defaultValue : undefined}
			disabled={disabled}
			name={name}
			onChange={onChange ? (event) => onChange(event.currentTarget.value) : undefined}
			required={required}
			value={value}
		>
			{timezones.map((timezone) => (
				<option key={timezone} value={timezone}>
					{timezone}
				</option>
			))}
		</select>
	);
}
